import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Uttamappa',   //theme name
        true,       //loadingSpinner
        true,      //fixedHeader
        true,      //fixedSidenav
        false,      //fixedSidenavUserContent
        false,      //fixedFooter
        true,       //sidenavIsOpened
        true,       //sidenavIsPinned  
        'vertical', //horizontal , vertical
        'default',  //default, compact, mini
        'indigo-light',   //indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
        false       // true = rtl, false = ltr
    )

    public numberPattern = '^[0-9]\\d*(\\.\\d{1,2})?$';
    public gstinPattern = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
    public pancard = '^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$';
    public onlyNumber = '^[0-9]+$';
    public namePattern = '^[a-zA-Z\\s]*';
    public ifscPattern = '^[A-Z]{4}0[A-Z0-9]{6}$';
    public aplhaNumeric = '^[A-Za-z0-9 ]+$';
    public aplhaNumericWithoutSpace = "^[a-zA-Z0-9]*$";
    public mobileNumber = '^((\\+91-?)|0)?[0-9]{10}$';
    public pincode = '^[1-9][0-9]{5}$';
    // public url = '/^(www.)[A-Za-z0-9 ]+$(.com)';
    public URL_PATTERN = "$" ;

    productTypeList = [
        {
            name: 'FASHION',
        },
        {
            name: 'ELECTRONICS',
        },
        {
            name: 'HOME',
        },
        {
            name: 'GROCERY',
        },
        {
            name: 'CLOTHING',
        }
    ]
}

